import { BinFilesState } from "./bin-files.state";
import { ActionTypes } from "./bin-files.actions";

export const BinFilesReducer = (
    state: BinFilesState = new BinFilesState(),
    action: any,
  ): BinFilesState => {

    switch (action.type) {

        case ActionTypes.GetBinFiles: {
            return {
                ...state,
                loading: true
            };
        }

        case ActionTypes.GetBinFilesSucceed: {
            const morePagesMode = (action.response.totalPages == null);
            return {
                ...state,
                record: action.response.items,
                pager: {
                    pageSize: action.pageSize,
                    page: action.page,
                    pageCount: morePagesMode ? action.response.morePages : action.response.totalPages,
                    morePagesMode
                },
                loading: false,
                error: null,
                ...action.stateExtensions
            };
        }

        case ActionTypes.GetBinFilesFail: {
            return {
                ...state,
                record: [],
                loading: false,
                error: action.error
            };
        }

        case ActionTypes.SortBinFiles: {
            return {
                ...state,
                loading: true,
                sorting: action.sorting
            };
        }

        case ActionTypes.FilterBinFiles: {
            return {
                ...state,
                loading: true,
                filter: action.filter
            };
        }

        default: {
            return state;
        }
    }

};
